import * as React from "react";
import { SVGProps, memo } from "react";

const SvgBellGray = (props: SVGProps<SVGSVGElement>) => (
  <svg width={21} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.458 15.833a.607.607 0 0 1-.625-.625.607.607 0 0 1 .625-.625H5.5V8.25c0-1.167.343-2.212 1.03-3.136a4.414 4.414 0 0 1 2.72-1.74v-.458c0-.347.121-.642.364-.885s.538-.365.886-.365c.347 0 .642.122.885.365s.365.538.365.885v.459a4.414 4.414 0 0 1 2.718 1.74A5.118 5.118 0 0 1 15.5 8.25v6.333h1.041a.607.607 0 0 1 .625.625.607.607 0 0 1-.625.625H4.458Zm6.042 2.5c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177h3.333c0 .459-.163.851-.49 1.178-.326.326-.718.49-1.176.49Z"
      fill="#576375"
    />
  </svg>
);

const Memo = memo(SvgBellGray);

export default Memo;
